import type { Story } from '../data'
import { storyRenderMode } from './render-mode'

/** The catalog's source attribution identifies a deliberately synthetic original. */
export function isAiGeneratedOriginal(story: Story): boolean {
  return story.sourceKind === 'audio' && /\bAI\b|인공지능|Supertonic/i.test(story.sourceLabel ?? '')
}

export function generatedAudioDisclosure(story: Story): string {
  const mode = storyRenderMode(story)
  if (mode === 'renarration') return 'AI가 동화 대본을 등록된 부모 목소리로 새로 읽어 생성한 음원이에요. 원본 음원의 배경음악·효과음·연기와 길이는 유지되지 않아요.'
  return mode === 'voice_conversion'
    ? 'AI가 원본 낭독을 부모 목소리로 변환해 생성한 음원이에요.'
    : 'AI가 등록된 목소리로 생성한 음원이에요.'
}
